import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Footer, Header } from "./headerFooter";
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { getHost } from './config';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";

const ForgotUsername = () => {

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            // Call the /register endpoint with the attributes needed
            const url = `${getHost()}/api/forgot-username`
            console.log(`Attempting to call: ${url}`); // Debugging URL
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email
                }),
            });

            const data = await response.json();

            // Check if the response is OK
            if (response.ok) {
                setSuccess(data.message || "Forgot username completed");
                setError('');
            } else {
                setError(data.message || "Try again");
                setSuccess('');
            }

        } catch (error) {
        // Handle errors (e.g., wrong credentials)
            setError('Forgot username failed, please try again');
            setSuccess('');
        }
    };
    
    const isFormValid = email !== '';
    
    return (
        <div id="root">
            <Header />
            <main className='center-container'>
                <Container className='custom-container p-3'>
                    {error && <Alert className='alert-error'>
                        {error}
                    </Alert>}

                    {success ? (
                        <div className="result">
                        <Alert className="alert-success">{success}</Alert>
                        <Button onClick={() => navigate('/')} variant="danger">Επιστροφή στην οθόνη εισόδου</Button>
                        </div>
                    ) : (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="forgotUsername.email">
                            <Form.Label className="custom-label">e-mail</Form.Label>
                            <Form.Control className="custom-form" type="email" value={email} onChange={(e) => setEmail(e.target.value.trimEnd())} required/>
                        </Form.Group>
                            <Button variant="danger" type="submit" disabled={!isFormValid}>Υπενθύμιση ονόματος χρήστη</Button>
                            
                        </Form>
                    )}
                
                </Container>
            </main>
            <Footer />
        </div>

  );


};

export default ForgotUsername;